// Mock API service for IPO data
const mockIPOData = [
  {
    id: 1,
    companyName: "TechCorp Solutions",
    companyLogo: "https://via.placeholder.com/60x60/007bff/ffffff?text=TC",
    subtitle: "Leading Technology Solutions Provider",
    issueDate: "2024-01-15",
    issueSize: "₹500 Cr",
    priceRange: "₹300-350",
    minInvestment: "₹45,000",
    lotSize: 150,
    quantity: "1,50,000 shares",
    issueDates: {
      start: "2024-01-15",
      end: "2024-01-18"
    },
    listedOn: "NSE, BSE",
    listedPrice: "₹385",
    listingGains: "+10.0%",
    gainsPositive: true,
    status: "Open",
    description: "TechCorp Solutions is a leading technology solutions provider specializing in cloud infrastructure, AI-powered analytics, and enterprise software solutions. The company has shown consistent growth over the past 5 years with a strong market presence in the fintech and healthcare sectors.",
    timeline: [
      { step: "Bidding starts", date: "Jan 15, 2024", completed: true },
      { step: "Bidding ends", date: "Jan 18, 2024", completed: false },
      { step: "Allotment finalization", date: "Jan 22, 2024", completed: false },
      { step: "Refund initiation", date: "Jan 23, 2024", completed: false },
      { step: "Demat transfer", date: "Jan 24, 2024", completed: false },
      { step: "Listing date", date: "Jan 25, 2024", completed: false }
    ]
  },
  {
    id: 2,
    companyName: "Green Energy Ltd",
    companyLogo: "https://via.placeholder.com/60x60/28a745/ffffff?text=GE",
    subtitle: "Renewable Energy Solutions",
    issueDate: "2024-01-20",
    issueSize: "₹750 Cr",
    priceRange: "₹250-300",
    minInvestment: "₹50,000",
    lotSize: 200,
    quantity: "2,00,000 shares",
    issueDates: {
      start: "2024-01-20",
      end: "2024-01-23"
    },
    listedOn: "NSE, BSE",
    listedPrice: "₹275",
    listingGains: "-8.3%",
    gainsPositive: false,
    status: "Upcoming",
    description: "Green Energy Ltd is a renewable energy company focused on solar and wind power generation across India. With over 500MW of installed capacity and ambitious expansion plans.",
    timeline: [
      { step: "Bidding starts", date: "Jan 20, 2024", completed: false },
      { step: "Bidding ends", date: "Jan 23, 2024", completed: false },
      { step: "Allotment finalization", date: "Jan 27, 2024", completed: false },
      { step: "Refund initiation", date: "Jan 28, 2024", completed: false },
      { step: "Demat transfer", date: "Jan 29, 2024", completed: false },
      { step: "Listing date", date: "Jan 30, 2024", completed: false }
    ]
  }
];

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const ipoService = {
  async getAllIPOs() {
    await delay(800);
    return mockIPOData;
  },

  async getIPOById(id) {
    await delay(500);
    const ipo = mockIPOData.find(item => item.id === parseInt(id));
    if (!ipo) {
      throw new Error('IPO not found');
    }
    return ipo;
  }
};